export default {
  externalUser: {
    value: false,
    options: [
      {text: 'Sim', value: true},
      {text: 'Não', value: false}
    ],
    required: true,
    state: null
  },
  matricula: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  mfaActive: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  funcionarioId: {
    value: '',
    options: [],
    required: true,
    state: null
  },
  funcionarioSubstitutoId: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  username: {
    value: '',
    maxlength: '70',
    required: true,
    state: null,
    disabled: false
  },
  administrador: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  permissoes: {
    value: null,
    options: [
      {name: 'Movimentação de Associados', value: 'MOVIMENTACAO'},
      {name: 'Visualização de Associados', value: 'VISUALIZACAO_ASSOCIADOS'},
      {name: 'Visualização de Cards', value: 'VISUALIZACAO_CARD'},
      {name: 'Visualização de Eventos', value: 'VISUALIZACAO_EVENTOS'}
    ],
    required: false,
    state: null
  },
  acessos: {
    value: null,
    options: [
      {name: 'Vendas', value: 'VENDA'},
      {name: 'Operações', value: 'OPERACAO'},
      {name: 'Cobranças', value: 'COBRANCA'}
    ],
    required: false,
    state: null
  },
  grupos: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  currentPassword: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  password: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  confirmation: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  pessoaId: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  nomePessoa: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/account/components/add/account-form.js